exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.menu[data-v-3b2b6a0a] {\n  display: block;\n}\n", ""]);

// exports
